import { api } from '@/lib/api';

const SDK_SRC = 'https://sdk.cashfree.com/js/v3/cashfree.js';
let _loading = null;

export const loadCashfree = () => {
  if (window.Cashfree) return Promise.resolve(true);
  if (_loading) return _loading;
  _loading = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SDK_SRC}"]`);
    const s = existing || document.createElement('script');
    let settled = false;
    const timer = setTimeout(() => {
      if (settled) return;
      settled = true; _loading = null;
      reject(new Error('Cashfree is taking too long to load — check your internet and try again'));
    }, 20000);
    const ok = () => { if (settled) return; settled = true; clearTimeout(timer); resolve(true); };
    const fail = () => { if (settled) return; settled = true; clearTimeout(timer); _loading = null; reject(new Error('Could not load Cashfree checkout')); };
    s.addEventListener('load', ok);
    s.addEventListener('error', fail);
    if (window.Cashfree) { ok(); return; }
    if (!existing) { s.src = SDK_SRC; s.async = true; document.body.appendChild(s); }
  });
  return _loading;
};

export const preloadCashfree = () => { loadCashfree().catch(() => {}); };

// Creates the order via `createPath` (provider=cashfree) then opens the hosted
// checkout as a full-page redirect. Returns { orderId } before navigating away.
export const startCashfreeCheckout = async ({ createPath = '/payments/razorpay/create-order', orderPayload = {}, returnPath } = {}) => {
  const origin = window.location.origin;
  const { data } = await api.post(createPath, { ...orderPayload, provider: 'cashfree', return_origin: origin, ...(returnPath ? { return_path: returnPath } : {}) });
  if (!data?.payment_session_id) throw new Error(data?.detail || 'Could not start Cashfree payment');
  await loadCashfree();
  const cashfree = window.Cashfree({ mode: data.cashfree_mode === 'production' ? 'production' : 'sandbox' });
  await cashfree.checkout({ paymentSessionId: data.payment_session_id, redirectTarget: '_self' });
  return { orderId: data.order_id };
};
